<template>
  <div class="evaluate-contain">
    <titleHeader title="商品评价" :cunstom-back="true" @goback="goback"></titleHeader>
    <!-- 多个商品时展示列表 -->
    <div class="" v-show="showGoodsList">
      <div class="goods-item" v-for="item in goodsList">
        <img class="goods-image" v-bind:src="item.picUrl" alt="">
        <div class="goods-content">
          <div class="goods-name over2line">{{item.goodsName}}</div>
          <div class="evaluate-btn" v-show="item.orderStatusId === 5" @click="gotoEvaluate(item)">填写评价</div>
        </div>
      </div>
    </div>
    <!-- 评价主体部分 -->
    <div class="" v-show="!showGoodsList">
      <div class="evaluation-header">
        <img class="goods-image" v-bind:src="goodsDetail.picUrl" alt="">
        <span class="evaluate-word">商品评价</span>
        <van-rate v-model="value" />
      </div>
      <van-cell-group>
        <van-field
          v-model="content"
          rows="4"
          autosize
          type="textarea"
          maxlength="50"
          show-word-limit
          placeholder="请输入评价，500字以内"
        />
      </van-cell-group>
      <div class="add-image">
        <span>添加图片(限9张)</span>
        <upload-image :max-size="9" @getImage="getImage"></upload-image>
      </div>
      <div class="submit-box">
        <van-button class="submit-btn" color="#45C5DA" type="primary" size="large" @click="submitEval">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
  import api from 'api/user';
  import uploadImage from 'components/upload-image';
  export default {
    components:{
      uploadImage
    },
    data(){
      return {
        goodsList:[],
        goodsDetail:{
          picUrl:'//img10.360buyimg.com/mobilecms/s80x80_jfs/t1/95710/10/3002/175184/5ddb3cffE8577493e/9b5d7ef5a4f0e0a5.jpg'
        },
        value: 0,//得分
        content:'',//评价内容
        showList: true,
        imageList:[]
      }
    },
    computed:{
      showGoodsList() {
        return this.goodsList.length > 1 && this.showList
      }
    },
    created() {
      this.goodsList = JSON.parse(this.$route.query.goodsList)
      if (this.goodsList.length === 1) {
        this.goodsDetail = this.goodsList[0];
      }
      console.log(this.goodsList);
    },
    methods: {
      goback(){
        if (this.goodsList.length > 1 && !this.showList) {
          //返回到评价列表
          this.showList = true;
        }else{
          this.$router.go(-1)
        }
      },
      getImage(list){
        console.log(list);
        this.imageList = list;
      },
      //评论某一个商品
      gotoEvaluate(item){
        this.showList = false;
        this.goodsDetail = item;
        console.log(item);
      },
      //提交评价
      submitEval() {
        const urlList = this.imageList.map(item=>{
          return {
            picUrl:item.url
          }
        })
        let params = {
          productId: this.goodsDetail.productId,
          goodsId: this.goodsDetail.goodsId,
          content: this.content,
          score: this.value,
          productEvaluatePictureMoList:urlList,
          orderGoodsId: this.goodsDetail.orderGoodsId
        }
        api.saveEvaluate(params)
        .then(res=>{
          console.log(res);
          this.$toast({
            type: 'success',
            message: '评价成功'
          });
          this.$router.push({
            name:'order'
          })
        })
      }
    }
  }
</script>

<style scoped lang="scss">
  @import 'common/sass/theme';
  .evaluate-contain{
    .goods-item{
      display: flex;
      height: 80px;
      padding: 0 10px;
      align-items: center;
      border-bottom: 1px solid $light-line-color;
      .goods-content{
        flex: 1;
        .goods-name{
          font-size: 14px;
        }
        .evaluate-btn{
          float: right;
          display: flex;
          justify-content: center;
          min-width: 70px;
          margin-left: 8px;
          padding: 5px 10px;
          font-size: 13px;
          border-radius: 5px;
          box-sizing: border-box;
          background: #fff;
          color: $theme-color;
          border: 1px solid $theme-color;
        }
      }
    }
    .goods-image{
      display: inline-block;
      width: 60px;
      height: 60px;
      margin-right: 10px;
    }
    .evaluation-header{
      display: flex;
      height: 80px;
      align-items: center;
      padding: 0 10px;
      border-bottom: 1px solid $light-line-color;
      .evaluate-word{
        margin: 0 10px;
      }
    }
    .add-image{
      margin: 5px 10px;
      font-size: 14px;
      span{
        display: inline-block;
        margin: 5px 0;
      }
    }
    .submit-box{
      display: flex;
      justify-content: center;
      .submit-btn{
        display: inline-block;
        width: 90vw;
        margin: 10px auto;
      }
    }
  }
</style>